module.exports = __webpack_public_path__ + "img/icon2.1a666c9.png";